import { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import { Route, useLocation, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col } from "react-bootstrap";
import _ from "lodash";
import ApiPaymentService from "../../../core/api/api.paymentService";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGridPayment from "./DataGridPayment";
import ModalPortal from "./Component/ModalPortal";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";

const PortalService = () => {
  const [listData, setListData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [showModalPortal, setShowModalPortal] = useState(false);
  const [selectedPortalId, setSelectedPortalId] = useState(null);
  let background = location.state && location.state.background;
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiPaymentService.getPortalList({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);

  const onSubmit = async (data) => {
    const apiData = await ApiPaymentService.getPortalList({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    tools.setPageNumber(data, searchParams, setValue);
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/portals?${queryString}`);
  };

  return (
    <div>
      {background && <Route path="/portals/modalPortal/:id" children={<ModalPortal />} />}

      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت درگاه</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست درگاه های بانکی ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setSelectedPortalId(0);
                setShowModalPortal(true);
              }}
            >
              <AddCircle className="mr-1" />
              افزودن درگاه جدید
            </Button>
          </div>
        </div>

        {/*Start body */}

        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                {/* search box */}
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGridPayment
                    data={listData}
                    setShowModalPortal={setShowModalPortal}
                    setSelectedPortalId={setSelectedPortalId}
                  />
                </Col>
                {showModalPortal && (
                  <ModalPortal
                    showModalPortal={showModalPortal}
                    setShowModalPortal={setShowModalPortal}
                    selectedPortalId={selectedPortalId}
                  />
                )}
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalService;
